import React from 'react';

import { Col, Container, Row, Card } from 'react-bootstrap';

import HttpErrorHandler from './HttpErrorHandler';

import './error.scss';
import HttpHeader from 'src/Member/shared/httpheader';
const cName = HttpHeader.getCNAME();

import ClientError from '../img/client-error.png';

//TODO: Re-factor the design
export default () => (
  <Container fluid>
    <Card className="mt-3 mb-3 p-5 card border-light">
      <Container className="mtop30 logout">
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />

        <Row className="h-100">
          <Col className="my-auto error-container">
            <img id="tick-img" alt="Check Mark" src={ClientError} />

            <Row className="w-50 mx-auto error-msg">
              <Col>
                <h1>Something went wrong!</h1>
                {cName.includes('mybenefits') ||
                cName.includes('roundstone') ? (
                  <>
                    <p>
                      {HttpErrorHandler.getErrorMessage()}{' '}
                      <a href="mailto:portalsupport@choosebywater.com">
                        mailto:portalsupport@choosebywater.com
                      </a>
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      {HttpErrorHandler.getErrorMessage()}{' '}
                      <a href="mailto:tpacustomerservice@keenan.com">
                        mailto:tpacustomerservice@keenan.com
                      </a>
                    </p>
                  </>
                )}
              </Col>
            </Row>
          </Col>
        </Row>

        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </Container>
    </Card>
  </Container>
);
